<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>会员管理</el-breadcrumb-item>
			<el-breadcrumb-item>账户积分管理</el-breadcrumb-item>
		</el-breadcrumb>
		<el-form :inline="true" :model="item" class="search">

			<el-form-item label="手机号码">
				<el-select v-model="item.mobile" filterable placeholder="请选择" size="medium">
					<el-option v-for="item in options" :key="item.id" :label="item.mobile" :value="item.mobile">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submit" size="medium">查询</el-button>
<!--				<el-button type="success" @click="excelOut" size="medium">导出</el-button>-->
			</el-form-item>
		</el-form>
		<div class="btns">
			<el-button v-if="store && store.jifen_recharge == 1" type="primary" size="small" @click="add" v-auth="['store/member/recharge']">账户积分增减</el-button>
		</div>

		<!--		数据是list 通过list展示-->
		<el-table :data="list" border>
			<el-table-column type="selection" align="center"></el-table-column>
			<el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column>

			<el-table-column prop="nick_name" label="昵称" width="200"></el-table-column>
			<el-table-column prop="mobile" label="手机" width="150"></el-table-column>
			<el-table-column width="60" align="center" label="增加/减少">
				<template slot-scope="scope">
					<div v-if="scope.row.type === 1">
						增加
					</div>
					<div v-else>
						减少
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="jifen" label="金额" width="180"></el-table-column>
			<el-table-column prop="created_date" label="创建时间"></el-table-column>
			<el-table-column prop="describe" label="描述"></el-table-column>
		</el-table>
		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page"
			:current-page.sync="pageNum" :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
</template>
<script>
	export default {
		name: 'index',
		data() {
			return {
				list: [],
				isLoad: false,
				pageNum: 0,
				pageSize: 20,
				total: 0,
				page: 1,
				// 查询
				item: {},
				options: [],
				store: {

				}
			}
		},
		created() {
			this.item = {
				page: this.page,
				limit: this.pageSize
			}
			this.loadStore()
			this.loadData()
			this.loadList()
		},
		methods: {
			loadStore: function () {
				this.axios.post('/store/index/store', this.item)
						.then(res => {
							this.store = res.data.store
						})
			},
			async loadData() {
				await this.axios.post('/store/member/list', {
				}).then(res => {
					this.options = res.data.list
				})
			},
			async loadList() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad

				let res = ""
				res = await this.axios.post('/store/member.jifen/list', this.item)
				// 获取数据
				this.list = res.data.list.data
				// 页数 page
				this.total = res.data.list.total
				this.isLoad = !this.isLoad

			},
			add() {
				this.$router.push({
					path: '/Member/integralEdit.html'
				});
			},
			sizeReload(val) {
				this.item.pageSize = val
				this.loadList()
			},

			// 分页
			pageReload(val) {
				this.item.page = val
				this.loadList()
			},
			// 搜索查询
			submit() {
				this.pageNum = 1
				this.item.page = 1
				this.loadList()
			},
			// 导出
			excelOut() {
				return;
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.get('/Member/excelOut', {
						params: {
							nickname: this.item.nickname,
							title: this.item.title
						}
					})
					.then(res => {
						this.isLoad = !this.isLoad
						// 导出
						window.open(res.url)
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			}
		}
	}
</script>
<style scoped>
	.el-form--inline .el-form-item {
		margin-bottom: 16px;
	}

	.search {
		margin-top: 16px;
	}
</style>
